/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiV3ServiceLinkCardGet$Params {

/**
 * Localization.
 */
  lang?: string;

/**
 * Type of applications
 */
  appType?: number;
}

export function apiV3ServiceLinkCardGet(http: HttpClient, rootUrl: string, params?: ApiV3ServiceLinkCardGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceLinkCardGet.PATH, 'get');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.query('appType', params.appType, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV3ServiceLinkCardGet.PATH = '/api/v3/service/linkCard';
